class SizeGuideTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.init()
  }

  init () {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
    this.navItems = Array.from(this.querySelectorAll('.sgd-Tabs_Tab'))
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'))

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.selectTab(tab))
    })

    this.navItems.forEach(item => {
      item.addEventListener('keydown', e => this.handleKeydown(e))
    })

    if (
      this.tabs.length &&
      !this.tabs.some(tab => tab.getAttribute('aria-selected') === 'true')
    ) {
      this.selectTab(this.tabs[0], { focus: false })
    }
  }

  selectTab (selectedTab, { focus = true } = {}) {
    this.tabs.forEach(tab => {
      const isSelected = tab === selectedTab
      tab.setAttribute('aria-selected', String(isSelected))
      tab.classList.toggle('sgd-Tabs_Tab-active', isSelected)
      tab.tabIndex = isSelected ? 0 : -1
    })

    this.panels.forEach(panel => {
      const isActive = panel.id === selectedTab.getAttribute('aria-controls')
      panel.hidden = !isActive
      panel.classList.toggle('sgd-Tabs_Panel-active', isActive)
    })

    if (focus && document.activeElement !== selectedTab) {
      selectedTab.focus()
    }
  }

  handleKeydown (e) {
    const idx = this.navItems.indexOf(e.currentTarget)
    let next

    if (e.key === 'ArrowRight') {
      next = this.navItems[(idx + 1) % this.navItems.length]
    } else if (e.key === 'ArrowLeft') {
      next = this.navItems[
        (idx - 1 + this.navItems.length) % this.navItems.length
      ]
    } else if (e.key === 'Home') {
      next = this.navItems[0]
    } else if (e.key === 'End') {
      next = this.navItems[this.navItems.length - 1]
    }

    if (!next) return

    next.focus()

    if (next.getAttribute('role') === 'tab') {
      this.selectTab(next)
    }
  }
}

customElements.define('size-guide-tabs', SizeGuideTabs)
